<template>
  <div class="home-container">
    <div class="bgc-box">
      <img class="bgc" :src="url + bgcImg" alt="" />
      <div class="titlebox">
        <img class="titImg" :src="url + titleImg" alt="" />
      </div>
      <div v-show="this.isShowRank" class="right-box" @click="torank()">
        <img class="rightImg" :src="url + rankImg" alt="" />
      </div>
      <div class="cjbox">
        <img
          v-show="isPrize == 1"
          class="zpbtnImg"
          @click="towhell()"
          src="../../assets/zpqietu/zpcj@2x.png"
          alt=""
        />
        <!-- <img class="rightImg" @click="torank()" :src="this.rankImg" alt="" /> -->
      </div>
      <!-- 弹出框 -->

      <van-popup
        v-model="ruleshow"
        closeable
        close-icon="close"
        position="center"
        :style="{ height: '55%' }"
      >
        <img class="dialogImg" src="@/assets/picture/hdgz@2x.png" />
        <h3>题型说明</h3>
        <div class="state-box">
          <p class="state-text" v-for="item in this.descriptions" :key="item">
            {{ item }}
          </p>
        </div>
        <!-- <p class="state-text">
        总共{{ this.total }}道题，每道题的时间为{{
          this.answerTime
        }}秒。{{ this.countList[0] }}道单选题、{{
          this.countList[1]
        }}道多选题、{{ this.countList[2] }}道填空题、{{
          this.countList[3]
        }}道问答题、{{ this.countList[4] }}道看图猜诗、{{
          this.countList[5]
        }}道宫格题点字成诗。
      </p> -->
        <h3 class="h3s">答题次数</h3>
        <div v-if="this.gameNums > 0" class="state-texts">
          <p class="state-days" v-if="this.gameNumsType == 1">
            活动期间总共答{{ this.gameNums }}次
          </p>
          <p class="state-days" v-else>每天可以答{{ this.gameNums }}次</p>
        </div>
        <div class="state-texts" v-else>不限次数</div>
      </van-popup>
      <div class="botbox">
        <div class="btn-box">
          <img
            class="btnImg"
            @click="onClick()"
            :src="url + this.btnImg"
            alt=""
          />
        </div>
        <p :style="libId === 2 ? '#cd3f09' : '#490505'">
          已有<span :style="libId === 2 ? '#cd3f09' : '#490505'">{{
            this.participantsNums
          }}</span
          >人次参与活动
        </p>
        <div class="bottexts">
          <h6>技术支持：杭州晨星创文网络科技有限公司</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActionInfo, getdingdingtoken } from "@/api/home";
import Common from "@/components/comm";
import qs from "qs";
import { Base64 } from "js-base64";
import { wxLogin } from "@/utils/wxLogin";
import { Toast } from "vant";
import { getwxConfig } from "@/utils/wxapi";
import { getActionConfig } from "@/api/rank";
import * as dd from "dingtalk-jsapi";
import axios from "axios";
import { GetCode } from "@/utils/Dingding.js";
export default {
  name: "home",
  components: {},
  props: {},
  data() {
    return {
      url: Common.getUrl(),
      bgcImg: "",
      titleImg: "",
      btnImg: "",
      participantsNums: "",
      rankImg: "",
      myBackground:"",
      myButton:"",
      // rankImg: require("../../assets/hd.png"),
      isShowRank: 0,
      startTime: "",
      endTime: "",
      params: {
        code: "",
        state: "",
      },
      tokenAuth: "",
      actionId: "",
      isPrize: "", //是否有抽奖活动 1有2没有
      ruleshow: false,
      descriptions: [], //题型说明
      gameNums: "", //答题次数
      viewsNums: "", //浏览次
      peopleCount: "", //参与人数
      participantsNums: "", //参与人次
      libId: "",
      customerId:''
    };
  },
  computed: {},
  watch: {},
  // ?tokenAuth=321810371990802400
  created() {
    var str = window.location.href;
    this.actionId = this.getQueryString("tokenAuth");
    // 判断url链接参数
    if (this.actionId) {
      this.$Cookies.set("ActionId", this.actionId);
    } else {
      if (!this.$Cookies.get("ActionId")) {
        this.$router.push("/blank");
      }
    }
    let codes = this.getQueryString("code");
    if (codes) {
      this.wxLogins();
    }
    // this.getwxConfigs();
    this.getActionInfos();
    this.getActionConfigs();
  },
  mounted() {},
  methods: {
    // 获取活动详情
    async getActionConfigs() {
      const { data: res } = await getActionConfig();
      this.isPrize = res.data.isPrize;
    },
    // 微信配置
    getwxConfigs: function () {
      getwxConfig();
    },
    // 获取url参数值
    getQueryString(param) {
      const reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)");
      const r =
        window.location.search.substr(1).match(reg) ||
        window.location.hash
          .substring(window.location.hash.search(/\?/) + 1)
          .match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
    },
    // 获取活动详情
    async getActionInfos() {
      const { data: res } = await getActionInfo();
      // let customerId = JSON.stringify(res.data.customerId);
      // console.log(customerId);
      if (res.data.customerId != "383390636453269504") {
        this.getwxConfigs();
      }
      this.customerId = res.data.customerId;
      this.bgcImg = res.data.backgroundImg;
      this.titleImg = res.data.titleImg;
      this.rankImg = res.data.rankImg;
      this.btnImg = res.data.buttonImg;
      window.localStorage.setItem("imgUrl", res.data.imgUrl);
      window.localStorage.setItem("myBackground", res.data.myBackground);
      window.localStorage.setItem("myButton", res.data.myButton);
      this.participantsNums = res.data.participantsNums;
      this.isShowRank = res.data.isShowRank;
      this.startTime = res.data.startTime;
      this.endTime = res.data.endTime;
      this.libId = res.data.libId;

      window.localStorage.setItem("libId", res.data.libId);
      this.peopleCount = res.data.peopleCount; //参与人数
      this.gameNums = res.data.gameNums; //答题次数
      this.gameNumsType = res.data.gameNumsType; //答题次数类型
      this.descriptions = res.data.descriptions; //题型说明
      this.viewsNums = res.data.viewsNums;
      if (res.data.descriptions) {
        this.descriptions = res.data.descriptions.split(";");
      }
    },
    // 微信登录
    async wxLogins() {
      this.params.code = this.getQueryString("code");
      this.params.state = this.getQueryString("state");
      const { data: res } = await wxLogin(qs.stringify(this.params));
      this.tokenAuth = res.data.token;
      if (this.tokenAuth) {
        this.$Cookies.set("auth", this.tokenAuth);
      }
    },
    // 钉钉免登录
    getddCode() {
      // 获取钉钉code方法  会返回登录 code
      GetCode(async (code) => {
        let data = { code: code };
        alert(code);
        const res = await getdingdingtoken(data);
        alert(res.data.data.token);
        let dingdtoken = res.data.data.token;
        if (dingdtoken) {
          this.$Cookies.set("auth", dingdtoken);
        }
      });
    },
    // 跳转登录类型
    loginType() {
      if (this.customerId == "383390636453269504") {
        this.getddCode();
      } else {
        const appid = "appid=" + "wx2092e534edde9aff" + "&";
        const redirect_uri =
          "redirect_uri=" +
          encodeURIComponent("https://vote.cxcwwlkj.com/transfer") +
          "&";
        const response_type = "response_type=" + "code" + "&";
        const scope = "scope=" + "snsapi_userinfo" + "&";

        const nowUrl = window.location.href;
        const base = Base64.encode("cxcw2021+" + nowUrl);
        const state = "state=" + base;
        const url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?" +
          appid +
          redirect_uri +
          response_type +
          scope +
          state +
          "#wechat_redirect";
        window.location.href = url;
      }
    },
    // 参与活动按钮点击事件
    onClick() {
      if (this.$Cookies.get("auth")) {
        var newDate = new Date().getTime();
        // 判断是否是在活动时间内
        if (this.startTime > newDate) {
          Toast("活动未开始");
          return;
        } else if (this.startTime < newDate && this.endTime > newDate) {
          this.$router.push("/my");
        } else {
          Toast("活动已结束");
          return;
        }
      } else {
        this.loginType();
      }
    },
    // 排行榜点击事件
    torank() {
      // this.ruleshow = true;
      if (this.$Cookies.get("auth")) {
        this.$router.push("/ranking");
      } else {
        this.loginTypes();
      }
    },
    // 转盘点击事件
    towhell() {
      if (this.$Cookies.get("auth")) {
        this.$router.push("/activeWheel");
      } else {
        this.loginTypes();
        // const appid = "appid=" + "wx2092e534edde9aff" + "&";
        // const redirect_uri =
        //   "redirect_uri=" +
        //   encodeURIComponent("https://vote.cxcwwlkj.com/transfer") +
        //   "&";
        // const response_type = "response_type=" + "code" + "&";
        // const scope = "scope=" + "snsapi_userinfo" + "&";

        // const nowUrl = window.location.href;
        // const base = Base64.encode("cxcw2021+" + nowUrl);
        // const state = "state=" + base;
        // const url =
        //   "https://open.weixin.qq.com/connect/oauth2/authorize?" +
        //   appid +
        //   redirect_uri +
        //   response_type +
        //   scope +
        //   state +
        //   "#wechat_redirect";
        // window.location.href = url;
      }
    },
  },
};
</script>

<style scoped lang="less">
.home-container {
  overflow: hidden;
}
.bgc-box {
  position: relative;
  width: 100%;
  height: 100vh;
  .bottexts {
    position: absolute;
    bottom: -140px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 41px;
    h6 {
      text-align: center;
      font-weight: bold;
      color: #010100;
      font-size: 20px;
    }
  }
}
.bgc {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
}
.titlebox {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 656px;
  height: 656px;
  text-align: center;
}
.cjbox {
  position: absolute;
  right: 155px;
  top: 15px;
  width: 149px;
  height: 135px;
  .zpbtnImg {
    width: 100%;
    height: 100%;
  }
}
.titImg {
  height: 100%;
}
.right-box {
  position: absolute;
  right: 0;
  top: 30px;
  width: 140px;
  height: 200px;
  text-align: center;
}
.rightImg {
  width: auto;
  max-height: 227px;
  margin-right: 10px;
  margin-top: -10px;
}
.botbox {
  position: absolute;
  bottom: 12%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 200px;
  text-align: center;
}
.btn-box {
  width: 100%;
}
.btnImg {
  // height: 90px;
  height: 120px;
}
p {
  margin-top: 30px;
  font-size: 26px;
  color: #490505;
}
span {
  color: #cd3f09;
  font-weight: bold;
}
h6 {
  text-align: center;
  font-weight: bold;
  color: #010100;
  font-size: 20px;
  line-height: 41px;
}
.dialogImg {
  position: relative;
  width: 584px;
  height: 543px;
}
h3 {
  position: absolute;
  top: 113px;
  left: 118px;
  font-family: "zihun";
  font-weight: 400;
  color: #b1420f;
  font-size: 30px;
}
.state-box {
  position: absolute;
  top: 164px;
  left: 117px;
  overflow-y: auto;
  height: 193px;
}
.state-text {
  width: 350px;
  font-size: 26px;
  font-weight: 500;
  color: #af7357;
  text-align: left;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 15px;
  margin-left: 20px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 8px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #bd937f;
}
.h3s {
  position: absolute;
  top: 398px;
  left: 118px;
  font-family: "zihun";
  font-weight: 400;
  color: #b1420f;
  font-size: 30px;
}
.state-texts,
state-days {
  position: absolute;
  top: 455px;
  left: 117px;
  font-size: 26px;
  font-weight: 500;
  color: #af7357;
  text-align: left;
  overflow-y: auto;
}
.browse {
  float: right;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  padding-right: 30px;
  margin-top: -10px;
}
.rightbox h1 {
  font-size: 28px;
  font-weight: 500;
  color: #f9e0b9;
}
::v-deep .van-popup {
  background-color: transparent;
}
::v-deep .van-popup__close-icon {
  position: relative;
  font-size: 52px;
}
::v-deep .van-popup__close-icon--top-right {
  right: -245px;
}
</style>
